import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/attendWorker/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/attendWorker/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/attendWorker/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/attendWorker/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/attendWorker/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function attendTeamList () {
  return axios({
    url: `/attendGroup/attendGroupDropDown`,
    method: 'Get'
  })
}

// 保存关联关系
export function addAttendGroup (params) {
  return axios({
    url: `/attendWorkerGroup/addAttendGroupList`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
// 删除关联关系
export function removeAttendGroupLink (params) {
  return axios({
    url: `/attendWorkerGroup/removeAttendGroupLink`,
    method: 'DELETE',
    data: {
      ...params
    }
  })
}

// 获取考勤小组
// export function getAttendTeam (id) {
//   return axios({
//     url: `/attendGroup/${id}`,
//     method: 'GET'
//   })
// }
